import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../app/shared/shared.module';
import { HomePageRoutingModule } from '../../../../app/home-page/home-page-routing.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { StatisticsModule } from '../../../../app/statistics/statistics.module';
import { JournalEntitiesModule } from '../../../../app/entity-groups/journal-entities/journal-entities.module';
import { ResearchEntitiesModule } from '../../../../app/entity-groups/research-entities/research-entities.module';
import { TopLevelCommunityItemComponent } from './top-level-community-list/top-level-community-item/top-level-community-item.component';

const DECLARATIONS = [
  TopLevelCommunityItemComponent
];

/**
 * OPARA: Dieses Modul stellt sicher, dass MatGridListModule und TopLevelCommunityItemComponent im Custom-Theme verfügbar sind
 */
@NgModule({
  imports: [
    CommonModule,
    SharedModule.withEntryComponents(),
    JournalEntitiesModule.withEntryComponents(),
    ResearchEntitiesModule.withEntryComponents(),
    HomePageRoutingModule,
    MatGridListModule,
    StatisticsModule.forRoot()
  ],
  declarations: [
    ...DECLARATIONS
  ],
  exports: [
    ...DECLARATIONS
  ],
})
export class HomePageModule {
}
